// interface

export interface AgentData {
      show:boolean,
    bannerImage:string,
    activeTab:number,


}
export interface RewardData {
    type: number,
    createTime: number | string,
    coin: number
}
export interface CommissionData {
    commission: number
    commissionRate: number
    total: number
}
export interface RewardDetails {
    summary: CommissionData
    details: DetailsItem[]
    totalPage: number
}
export interface DetailsItem {
    fromUid: number
    turnover: number
    coin: number
    level: number
}
export interface BettingRewards {
    levelName: number | string,
    value: number | string
}
export interface RechargeRewards {
    cumulativeRechargeAmount: number | string,
    giveAway: number | string
}
export interface DirectRecharge {
    levelName: number | string,
    value: number | string
}
export interface UserData {
    direct_commission: number
    total_commission: number
    direct_bet: number
    total_bet: number
    new_direct_user_count: number
    new_user_count: number
    direct_recharge: number
    total_recharge: number
    new_direct_first_recharge_count: number
    new_first_recharge_count: number
    team_commission: number
    team_bet: number
    team_recharge: number
    new_team_user_count: number
    new_team_first_recharge_count: number
}
export interface MyDataItem {
    start_time: number
    end_time: number
    user_data: UserData
}
// Constant

export const TAB_LIST = [
 { name: 'agent.invitation', notice_type: 0, },
    { name: 'agent.myData', notice_type: 1, },
    { name: 'agent.commission', notice_type: 2, },
    { name: 'agent.detailed', notice_type: 3, },
    { name: 'agent.faq', notice_type: 4, },
]
export const MY_DATA_TAB_LIST = [
{ name: 'myDataView.today', notice_type: 0, },
{ name: 'myDataView.yesterday', notice_type: 1, },
{ name: 'myDataView.thisWeek', notice_type: 2, },
{ name: 'myDataView.lastWeek', notice_type: 3, },
{ name: 'myDataView.thisMonth', notice_type: 4, },
{ name: 'myDataView.lastMonth', notice_type: 5, }
]

export const SHARE_LIST = [
    { img: require('@/assets/sideNavbar/home_share_share.png'), name: 'common.more' },
    { img: require('@/assets/sideNavbar/facebook_cai.png'), name: 'socialMedia.facebook'},
    { img: require('@/assets/sideNavbar/Whatsapp_cai.png'), name: 'socialMedia.whatsapp' },
    { img: require('@/assets/sideNavbar/Telegram_cai.png'), name: 'socialMedia.telegram' },
    { img: require('@/assets/sideNavbar/insgram_cai.png'), name: 'socialMedia.instagram'},
    { img: require('@/assets/sideNavbar/kwai_cai.png'), name: 'socialMedia.kwai' },
    { img: require('@/assets/sideNavbar/twitter_cai.png'), name: 'socialMedia.twitter' },
    { img: require('@/assets/sideNavbar/TikTok_cai.png'), name: 'socialMedia.tiktok' },
    { img: require('@/assets/sideNavbar/Youtube_cai.png'), name: 'socialMedia.youTube' },
]

//function
import { Ref } from 'vue'

export const getActivityInfoFunc = async <T extends (event: any, ...args: any[]) => void>(
  getActivityInformations: (params: any) => Promise<any>,
  loadingRef: Ref<any>,
  copyUrl: Ref<string>,
  showError: (message: string) => void,
  emits: T
) => {
  const params = {
    activityId: 'user_referral_reward',
  }

  try {
    const res = await getActivityInformations(params)
    loadingRef.value.close()
    if (res.data) {
      copyUrl.value = res.data?.config?.link || ''
    }
  } catch (err: any) {
    if (err.code !== 401) {
      showError(err)
      loadingRef.value.close()
    } else {
      emits('closePoup')
    }
  }
}

export const getAgentInfoDataFunc = async <T extends (event: any, ...args: any[]) => void>(
  getAgentInfo: () => Promise<any>,
  loadingRef: Ref<any>,
  directRechargeList: Ref<any[]>,
  subTabList: Ref<any[]>,
  activeCumulativeRecharge: Ref<any>,
  bettingRewardList: Ref<any[]>,
  betTabList: Ref<any[]>,
  activeCumulativeBet: Ref<any>,
  teamPerformanaceList: Ref<any[]>,
  showError: (message: string) => void,
  emits: T
) => {
  try {
    const res = await getAgentInfo()
    loadingRef.value.close()

    if (res.data) {
      directRechargeList.value = res.data?.recharge?.levels || []
      subTabList.value = res.data?.cumulativeRecharge?.level_config || []
      activeCumulativeRecharge.value = subTabList.value[0] || {}
      bettingRewardList.value = res.data?.betting?.levels || []
      betTabList.value = res.data?.cumulativeBetting?.level_config || []
      activeCumulativeBet.value = betTabList.value[0] || {}
      teamPerformanaceList.value = res.data?.teamPerformance?.team_performance_rate || []
    }
  } catch (err: any) {
    if (err.code !== 401) {
      showError(err)
      loadingRef.value.close()
    } else {
      emits('closePoup')
    }
  }
}

export const getMyDataListFunc = async (
  getMyData: (params: any) => Promise<any>,
  active: Ref<number>,
  myData: Ref<any>,
  loadingRef: Ref<any>,
  showError: (message: string) => void
) => {
  const params = {
    type: active.value + 1
  }

  try {
    const res = await getMyData(params)
    myData.value = res.data
  } catch (err: any) {
    showError(err)
  } finally {
    loadingRef.value.close()
  }
}

export const getRewardDataFunc = async (
  getRewardList: (params: any) => Promise<any>,
  pageNumber: Ref<number>,
  rewardData: Ref<any[]>,
  total: Ref<number>,
  loadingRef: Ref<any>,
  showError: (message: string) => void
) => {
  const params = {
    pageNum: pageNumber.value,
    pageSize: 20
  }

  try {
    const res = await getRewardList(params)
    rewardData.value = [...rewardData.value, ...res.data.rows]
    total.value = res.data.total
    pageNumber.value = pageNumber.value + 1
  } catch (err: any) {
    showError(err)
  } finally {
    loadingRef.value.close()
  }
}

export const getNextPageRewardDataFunc = async (
  total: Ref<number>,
  pageSize:Ref<number>,
  getRewardData:()=>void,
  loadingRef: Ref<any>
) =>{
      if (total.value > pageSize.value) {
        loadingRef.value.open()
        getRewardData()
        pageSize.value = pageSize.value + 20
    }
}

export const getRewardDetailDataFunc = async (
  getRewardDetail: (params: any) => Promise<any>,
  date: Ref<string>,
  pageNumber: Ref<number>,
  activeType: Ref<number>,
  rewardData: Ref<any>,
  detailsList: Ref<any[]>,
  total: Ref<number>,
  loadingRef: Ref<any>,
  showError: (message: string) => void
) => {
  const params = {
    date: date.value,
    pageNum: pageNumber.value,
    pageSize: 20,
    type: activeType.value
  }

  try {
    const res = await getRewardDetail(params)
    rewardData.value = res.data
    detailsList.value = [...detailsList.value, ...(rewardData.value?.details || [])]
    total.value = rewardData.value?.totalPage || 0
    pageNumber.value = pageNumber.value + 1
  } catch (err: any) {
    showError(err)
  } finally {
    loadingRef.value.close()
  }
}

export const getNextPageDetailsViewDataFunc = async (
  total: Ref<number>,
  pageNumber:Ref<number>,
  getRewardData:()=>void,
  loadingRef: Ref<any>
) =>{
       if (total.value >= pageNumber.value) {
        loadingRef.value.open()
        getRewardData()
    }
}

export const copyHandleFunc = async (
  toastContent: Ref<string>,
  isSuccess: Ref<boolean>,
  copyUrl:Ref<string>,
  statusRef:Ref<any>,
  t: (key: string) => string
)=>{
      toastContent.value = t('common.copied');
    isSuccess.value = true;
    if (copyUrl.value) {
        navigator.clipboard.writeText(copyUrl.value);
        statusRef.value.open();
    }
}